export var StorageKey;
(function (StorageKey) {
    StorageKey["DisableAnimations"] = "disable-animations";
})(StorageKey || (StorageKey = {}));
